<template>
  <div class="resultSingUp">
    <div class="hgroup">
    <h2>CONFIRM MY APPROVAL</h2>
    <p>Welcome back to the Dashboard.
      Scroll down to see quick links and <br />overviews of your Server, To do list, Order status or get some Help using Nifty.</p>
  </div>
    <div class="boxType1 resultSingUp">
      <p v-if="userStatus.isHtmlMessage" class="txt" v-html="$t(userStatus.message)"></p>
      <p v-else class="txt">{{ $t(userStatus.message) }}</p>

      <dl>
        <dt>COMPANY</dt><dd>{{ model.companyTypeName }} : {{ model.companyName }}</dd>
        <dt>ID</dt><dd>{{ model.email }}</dd>
      </dl>

      <p class="btns" v-if="userStatus">
        <template v-for="(item, index) in userStatus.buttons">
          <button :key="index"
            type="button"
            :class="item.isPrimary ? 'btn_2' : 'btn_3'"
            @click="onActionClick(item.action)">{{ $t(item.label) }}</button>&nbsp;
        </template>
      </p>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters, mapMutations } from 'vuex'
import authApi from '@/api/auth'
import accountApi from '@/api/account'
import userStatusData from '@/data/user-status'
import modalEvent from '@/lib/modal-event'
import ajaxHandlerMixin from '@/mixins/ajax-handler'

export default {
  name: 'AccountStatus',
  mixins: [ajaxHandlerMixin],
  data () {
    return {
      isDataReady: false,
      // isValidMember: false,
      model: {
        companyTypeName: null,
        companyName: null,
        email: null,
        roleCode: null,
        statusCode: null
      }
    }
  },
  computed: {
    ...mapGetters(['justSignUp']),
    userStatus () {
      if (!this.isDataReady) {
        return {}
      }

      if (this.justSignUp) {
        this.setJustSignUp(false)
        return userStatusData.justSignUp
      }

      switch (this.model.statusCode) {
        case 0:
          return userStatusData.notApproved
        case 1:
          return userStatusData.approved
        case 2:
          return userStatusData.rejected
        default:
          throw new Error('invalid user status code')
      }
    }
  },
  created () {
    accountApi.findSignUpStatus().then(response => {
      const data = response.data

      if (data) {
        this.model = _.pick(data, ['id', 'email', 'roleCode', 'statusCode'])
        this.model.companyTypeName = data.Company.CompanyType.name
        this.model.companyName = data.Company.name
        // this.isValidMember = true
      } else {
        throw this.getOperationError()
      }

      this.isDataReady = true
    }).catch(this.handleAjaxError)
  },
  methods: {
    ...mapMutations(['setJustSignUp', 'clearUserData']),
    goSignIn () {
      authApi.signOut().then(() => {
        this.clearUserData()
        this.$router.replace({ name: 'SignIn' })
      }).catch(this.handleAjaxError)
    },
    onActionClick (action) {
      switch (action) {
        case 'onGoMainClick':
          this.$router.push({ name: 'Main' })
          break
        case 'onSignInClick':
          this.goSignIn()
          break
        case 'onSignUpCancelClick':
          modalEvent.openDialog({
            message: 'userStatus.cancelSignUpMessage',
            ok: 'common.yes',
            cancel: 'common.no'
          }).then(result => {
            if (result) {
              accountApi.removeUser().then(response => {
                this.clearUserData()
                modalEvent.openToast('userStatus.signUpCancelled').then(() => {
                  this.$router.replace({ name: 'SignIn' })
                })
              }).catch(this.handleAjaxError)
            }
          })
          break
        case 'onRetryClick':
          accountApi.reApply().then(response => {
            if (response.data) {
              modalEvent.openToast('userStatus.reapprovalRequested').then(() => {
                this.model.statusCode = 0
              })
            } else {
              throw this.getOperationError()
            }
          }).catch(this.handleAjaxError)
          break
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/member/AccountStatus.vue